import { useForm } from 'react-hook-form';
import { useSearchParams } from 'react-router-dom';
import useGetHook from '../../../customHooks/useGetHook';
import Button from '../../Reusable/Button';
import TextField from '../../Reusable/TextInput';
//@ts-ignore
import { tw } from '@careinfo/tailwind';
import NextStatusCombobox from '../../Reusable/NextStatusCombobox';
import APIS from '../../../constant/Endpoint';

const ChangeStatus = ({ handleActionMenu, isLoading }: any) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    setError,
    getValues,
    watch,
    clearErrors,
  } = useForm<any>();

  const { data } = useGetHook({
    queryKey: [watch('status')],
    url: watch('status') ? `${APIS.STATUS}${watch('status')}/` : APIS.STATUS,
    params: {},
  });
  const [searchParams, setSearchParms] = useSearchParams();
  const orderIds = searchParams.get('selectedItems')?.split(',') || [];
  return (
    <form
      onSubmit={handleSubmit((data: any) =>
        handleActionMenu(data, 'Change Status', setError)
      )}
      autoComplete='off'
    >
      <div className={tw`flex flex-col justify-between min-h-full`}>
        <NextStatusCombobox
          url={APIS.STATUS_NEXT}
          queryKey={'status'}
          register={register('status' as const, {
            required: 'Status is required',
          })}
          errors={errors?.status}
          name={'status'}
          watch={watch}
          label={''}
          setValue={setValue}
          placeholder={'Search Status'}
          getValues={getValues}
          props={{ order_ids: orderIds }}
          clearErrors={clearErrors}
        />
        {!Array.isArray(data) && data?.is_partial_status ? (
          <>
            <TextField
              label={'Collected COD'}
              register={register('collected_cod' as const, {
                required: 'Collected COD is required',
              })}
              errors={errors?.collected_cod}
            />
            <TextField
              label={'Remark'}
              register={register('remark' as const, {
                required: 'Remark is required',
              })}
              errors={errors?.remark}
            />
          </>
        ) : (
          ''
        )}
        <div className={tw`w-[100px] mr-4 absolute bottom-4 right-2`}>
          <Button label={'Submit'} isLoading={isLoading} />
        </div>
      </div>
    </form>
  );
};

export default ChangeStatus;
